// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b2e9129c6f67a39a75b0e81b6d7a64c5.js";
};